import ArtistHeader from "../../shared/ArtistHeader/header";
import FanHeader from "../../shared/FanHeader/header";
import Header from "../../shared/header/header";
import Footer from "../../shared/footer/footer";

const PrivacyPolicy = () => {
	return (
		<div>
			{localStorage.getItem("tokenFan") ? (
				<FanHeader />
			) : localStorage.getItem("tokenArtist") ? (
				<ArtistHeader />
			) : (
				<Header />
			)}

			<section id="content" className="pt40">
				<div className="container">
					<div className="row">
						<div className="col-md-12">
							<div className="privacy-policy-content">
								<div className="privacy-policy-heading">
									<h1 className="text-green din-font text-uppercase text-center">
										Privacy Policy
									</h1>
									<br></br>
								</div>

								<div className="privacy-content text-color">
									<p >
										<strong>DalbumX LLC</strong> ("DalbumX," "we," "us," or "our") is committed to protecting your privacy.
										 This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use 
										 the DalbumX platform — including our website at www.dalbumx.com (the "Website"), our mobile application
										  (the "App"), and all related services (collectively, the "Service"). This Privacy Policy applies to both 
										  the Website and the App.
									</p>

									<p>
										This Privacy Policy is accessible within the DalbumX mobile app under Settings &gt; Privacy Policy, and online
										at www.dalbumx.com/privacy-policy. 
										<p>A summary of our data practices is also available on our Google Play Store and
										Apple App Store listings under "Data Safety" and "App Privacy" respectively.</p>
									</p>

									<p>
										Please read this Privacy Policy carefully. If
										you do not agree with its terms, please do not
										use the Service.
									</p>

									<p>
										<strong>Age Requirement:</strong> The DalbumX
										Service is intended solely for users who are 18
										years of age or older residing in the United
										States. By using the Service, you represent and
										warrant that you meet both of these requirements.
									</p>

									<h2 className="fw-bold mt-4 mb-3 heading-bold">1. INFORMATION WE COLLECT</h2>

									<h3 className="fw-bold mt-3 mb-2 heading-bold">1.1 Information You Provide to Us</h3>

									<h4 className="fw-bold mt-3 mb-2 heading-bold">Account Information (Website and Mobile App)</h4>
									<p>When you create a DalbumX account, we collect:</p>

									<ul>
										<li>Name (legal name and/or artist name)</li>
										<li>Email address</li>
										<li>
											Username and password (passwords are stored
											using one-way cryptographic hashing — never
											in plain text)
										</li>
										<li>
											Date of birth (for age verification only —
											confirming you are at least 18 years of age)
										</li>
									</ul>

									<h4 className="fw-bold mt-3 mb-2 heading-bold">Artist Information (Website Only)</h4>
									<p>
										Artists who publish Dalbums through the Website
										additionally provide:
									</p>

									<ul>
										<li>
											<strong>Payment account details:</strong> Payment email
											address or account information for receiving
											sales revenue and payouts
										</li>
										<li>
											<strong>Tax documentation:</strong> DalbumX does not collect
											Social Security Numbers, Employer
											Identification Numbers, or tax identification
											data directly. All tax documentation is
											handled through our third-party payment
											processors
										</li>
										<li>
											<strong>Dalbum content and metadata:</strong> Audio files,
											artwork, photographs, videos, lyrics, liner
											notes, track names, genre, credits, pricing,
											and all associated materials uploaded through
											the Artist Portal
										</li>
									</ul>

									<h4 className="fw-bold mt-3 mb-2 heading-bold">Purchase Information (Website Only)</h4>
									<p>
										When Fans make purchases through the Website, we
										collect:
									</p>

									<ul>
										<li>
											Purchase history and transaction records
										</li>
										<li>
											<strong>Payment information: </strong> Processed by our
											third-party PCI-DSS compliant payment
											processors. DalbumX does not store complete
											credit card numbers or sensitive payment
											credentials
										</li>
									</ul>

									<h4 className="fw-bold mt-3 mb-2 heading-bold">Communications (Website and Mobile App)</h4>
									<p>
										When you contact us, we collect the content of
										your communications, including support requests,
										DMCA notices, and feedback.
									</p>

									<h3 className="fw-bold mt-3 mb-2 heading-bold">1.2 Information Collected Automatically</h3>

									<h4 className="fw-bold mt-3 mb-2 heading-bold">Website — Usage Data</h4>
									<p>
										When you use the Website, we automatically
										collect:
									</p>

									<ul>
										<li>
											Device type, operating system, and browser
											type
										</li>
										<li>
											IP address and approximate geographic
											location (city/metro level)
										</li>
										<li>
											Pages visited, features used, and time spent
											on the Website
										</li>
										<li>Dalbums browsed and purchased</li>
									</ul>

									<h4 className="fw-bold mt-3 mb-2 heading-bold">Mobile App — Technical Data</h4>
									<p>
										When you use the App, we collect the following
										limited technical information:
									</p>

									<ul>
										<li>
											<strong>Authentication token:</strong> Stored securely in your
											device's native keychain (iOS) or keystore
											(Android). Used solely to maintain your login
											session. Not transmitted to third parties
										</li>
										<li>
											<strong>App version and platform:</strong> Sent to the
											DalbumX API solely to verify compatibility
											and prompt updates when necessary. Not shared
											with third parties
										</li>
										<li>
											<strong>Local playback data:</strong> Track metadata and audio
											file references are accessed locally on your
											device to support music playback, including
											background playback. This data is not
											transmitted externally
										</li>
									</ul>

									<p>
										<strong>What the App Does Not Collect:</strong>{" "}
										The DalbumX mobile application does not collect
										the Android Advertising ID (GAID) or any mobile
										advertising identifier. The App contains no
										advertising SDKs, analytics SDKs, or
										crash-reporting SDKs. The App does not access
										your device's camera, microphone, GPS location,
										or external storage.
									</p>

									<h4 className="fw-bold mt-3 mb-2 heading-bold">Local Storage and Cookies</h4>

									<p>
										<strong>Website:</strong> The Website does not
										use browser cookies. The Website uses browser
										Local Storage and Session Storage to maintain
										your login session and preferences. This data is
										stored locally in your browser and is not
										transmitted to third parties. You may clear it
										at any time through your browser settings,
										though doing so will log you out.
									</p>

									<p>
										<strong>Mobile App:</strong> The App does not
										use browser cookies or Local Storage.
										Authentication data is stored exclusively in
										your device's native secure storage
										(keychain/keystore).
									</p>

									<h4 className="fw-bold mt-3 mb-2 heading-bold">Embedded Video Content</h4>
									<p>
										Artists may embed videos from YouTube and Vimeo
										within their Dalbums. When you view such videos
										in the App, they stream directly from those
										platforms' servers. YouTube and Vimeo may
										independently collect data through their
										embedded players pursuant to their own privacy
										policies. DalbumX does not control or receive
										this data. Not all Dalbums contain embedded
										video — this is at each artist's discretion.
									</p>

									<h2 className="fw-bold mt-4 mb-3 heading-bold">2. HOW WE USE YOUR INFORMATION</h2>

									<p>
										We use the information we collect to:
									</p>

									<ul>
										<li>
											<strong>Provide the Service:</strong> Create and manage
											accounts, process purchases, deliver Dalbums,
											and enable all core platform features
										</li>
										<li>
											<strong>Process Payments:</strong> Facilitate secure
											transactions between Fans and Artists and
											issue Artist payouts through our third-party
											payment processors
										</li>
										<li>
											<strong>Communicate with You:</strong> Send transactional
											emails including purchase confirmations,
											payment notifications, DMCA notices, security
											alerts, and support responses. You cannot opt out of transactional communications
										</li>
										<li>
											<strong>Improve the Service:</strong> Analyze Website usage
											patterns, troubleshoot issues, and develop
											new features
										</li>
										<li>
											<strong>Enforce Our Policies:</strong> Monitor for violations
											of our Terms of Service and Content Policy,
											respond to copyright claims, and prevent
											fraud
										</li>
										<li>
											<strong>Comply with Legal Obligations:</strong> Respond to
											lawful legal process and government requests,
											and maintain records as required by law
										</li>
										<li>
											<strong>Marketing (Opt-In Only):</strong> Send promotional
											communications with your explicit prior
											consent. You may opt out at any time
										</li>
									</ul>

									<p>
										<strong>We do not: </strong>sell your personal information, use
										it for third-party advertising, or share it with
										third parties for their own marketing or
										advertising purposes.
									</p>

									<h2 className="fw-bold mt-4 mb-3 heading-bold">3. HOW WE SHARE YOUR INFORMATION</h2>

									<p>
										<strong>We do not sell your personal information.</strong> We
										share your information only in the following
										limited circumstances:
									</p>

									<h3 className="fw-bold mt-3 mb-2 heading-bold">3.1 Service Providers</h3>
									<p>We work with trusted third-party service providers 
										who are contractually obligated to protect your data 
										and may only use it to provide services to DalbumX:
									</p>

									<ul>
										<li>
											<strong>Payment processors:</strong> Fan purchases and Artist
											payouts are handled by PCI-DSS Level 1
											compliant third-party payment processors. 
											DalbumX does not store complete credit card numbers or 
											sensitive payment credentials
										</li>
										<li>
											<strong>Cloud infrastructure:</strong> Application servers are
											hosted on DigitalOcean. Database services are
											hosted on Amazon Web Services (AWS)
										</li>
										<li>
											<strong>Email delivery:</strong> We use a third-party email
											service provider to send transactional and
											marketing communications
										</li>
									</ul>

									<h3 className="fw-bold mt-3 mb-2 heading-bold">3.2 Publicly Visible Information</h3>
									<p>The following information is publicly visible on the DalbumX platform by design:</p>

									<ul>
										<li>
											<strong>Artist profiles:</strong> name, biography, profile
											photo, and social media links
										</li>
										<li>
											<strong>Dalbum listings:</strong> title, track names,
											artwork, credits, genre, and pricing
										</li>
									</ul>

									<h3 className="fw-bold mt-3 mb-2 heading-bold">3.3 Legal Requirements and Safety</h3>
									<p>
										We may disclose your information when required
										by law or when we believe in good faith that
										disclosure is necessary to comply with legal
										process, respond to lawful government requests,
										enforce our policies, or protect the rights,
										property, or safety of DalbumX, our users, or
										the public.
									</p>

									<h3 className="fw-bold mt-4 mb-3 heading-bold">3.4 Copyright Notices</h3>
									<p>
										Processing copyright takedown notices and
										counter-notices may require sharing relevant
										contact information between the parties
										involved, as required by applicable law.
									</p>

									<h3 className="fw-bold mt-4 mb-3 heading-bold">3.5 Business Transfers</h3>
									<p>
										In the event of a merger, acquisition, or sale
										of assets, your information may be transferred
										to the acquiring entity. We will provide at
										least 30 days' notice before any such transfer
										via email and/or a prominent notice on the
										Service.
									</p>

									<h2 className="fw-bold mt-4 mb-3 heading-bold">4. DATA RETENTION</h2>

									<p>
										We retain your information for as long as necessary to provide the Service, subject to the following:
									</p>

									<div className="table-responsive">
									<table className="table table-bordered align-middle style={{fontSize: '16px'}}">
										<thead className="table-dark">
											<tr>
												 <th style={{fontSize: '18px'}}>Data Type</th>
												 <th style={{fontSize: '18px'}}>Retention Period</th>
											</tr>
										</thead>

										<tbody>
											<tr>
												<td><strong>Account information</strong></td>
												<td>
													Duration of account. Archived 30 days upon deletion,
													then permanently deleted
												</td>
											</tr>

											<tr>
												<td>
													<strong>
														Payment and transaction records
													</strong>
												</td>
												<td>
													7 years minimum, as required by applicable tax law
												</td>
											</tr>

											<tr>
												<td><strong>Dalbum content files</strong></td>
												<td>
													Duration of publication. Deleted within 30 days of
													removal or account termination
												</td>
											</tr>

											<tr>
												<td><strong>Website usage logs</strong></td>
												<td>90 days</td>
											</tr>

											<tr>
												<td><strong>Copyright/DMCA records</strong></td>
												<td>
													3 years, per applicable safe harbor requirements
												</td>
											</tr>

											<tr>
												<td><strong>Support communications</strong></td>
												<td>3 years from date of communication</td>
											</tr>

											<tr>
												<td><strong>App authentication tokens</strong></td>
												<td>
													Device only. Invalidated upon logout or account
													deletion
												</td>
											</tr>
										</tbody>
									</table>
									<br></br>
									<p>To request deletion of your account and associated data, see Section 6.3 below.</p>
								</div>

									<h2 className="fw-bold mt-4 mb-3 heading-bold">5. DATA SECURITY</h2>

									<p>
										We implement commercially reasonable administrative, technical, 
										and physical security measures designed to protect your personal 
										information from unauthorized access, use, disclosure, alteration, or destruction:
									</p>
									<ul>
										<li><strong>Encryption in transit:</strong> All data transmitted between 
											you and DalbumX — via both the Website and the App — 
											is encrypted using SSL/TLS protocols
										</li>
										<li>
											<strong>Password security:</strong> Passwords are stored using one-way 
											cryptographic hashing and are never stored or accessible in plain text
										</li>
										<li><strong>Mobile app security:</strong> Authentication tokens are stored exclusively in your
											 device's native secure enclave — keychain (iOS) or keystore (Android)</li>
										<li>
											<strong>Payment security:</strong> We use PCI-DSS Level 1 compliant payment processors 
											and do not store payment credentials on our own systems
										</li>
										<li>
											<strong>Access controls:</strong> Access to personal information is restricted to 
											authorized DalbumX personnel on a need-to-know basis
										</li>
									</ul>
									<p>
										No method of data transmission or storage is 100% secure.
										While we strive to protect your personal information using 
										commercially reasonable means, we cannot guarantee absolute security.
										In the event of a data breach affecting your personal information, 
										we will notify you without unreasonable delay and in accordance with
										applicable state and federal law
									</p>

									<h2 className="fw-bold mt-4 mb-3 heading-bold">6. YOUR PRIVACY RIGHTS</h2>

									<h3 className="fw-bold mt-4 mb-3 heading-bold">6.1 Access and Correction</h3>
									<p>
										You may access and update your account
										information at any time through your account
										settings or by contacting us at
										support@dalbumx.com.
									</p>

									<h3 className="fw-bold mt-4 mb-3 heading-bold">6.2 Marketing Opt-Out</h3>
									<p>
										You may opt out of promotional emails at any
										time by clicking the unsubscribe link in any
										marketing email or by updating your preferences 
										in your account settings. You cannot opt out of
										transactional communications such as purchase confirmations,
										payment notifications, and security alerts.
									</p>

									<h3 className="fw-bold mt-4 mb-3 heading-bold">6.3 Account Deletion</h3>
									<p>
										You may delete your account at any time through your account
										settings on the DalbumX Website, or by contacting us directly 
										at support@dalbumx.com. Upon requesting deletion, your account
										will be archived for 30 days to allow for reactivation if you 
										change your mind. After 30 days, your account and associated personal 
										data will be permanently and irreversibly deleted. Certain records 
										are retained beyond this period as required by applicable law — see
										Section 4 for specific retention periods.
									</p>

									<h3 className="fw-bold mt-4 mb-3 heading-bold">6.4 California Residents — CCPA/CPRA Rights</h3>
									<p>
										If you are a California resident, you have the following 
										rights under the California Consumer Privacy Act (CCPA) as
										amended by the California Privacy Rights Act (CPRA):
									</p>
									<ul>
										<li><strong>Right to Know:</strong> Request information about what personal 
											information we collect, use, and share
										</li>
										<li>
											<strong>Right to Delete:</strong> Request deletion of your personal information, 
											subject to legal exceptions
										</li>
										<li><strong>Right to Correct:</strong> Request correction of inaccurate personal 
											information we hold about you
										</li>
										<li>
											<strong>Right to Opt Out of Sale or Sharing:</strong> DalbumX does not sell 
											your personal information and does not share it for cross-context 
											behavioral advertising. There is nothing to opt out of in this regard
										</li>
										<li>
											<strong>Right to Non-Discrimination:</strong> We will not discriminate against you for
										    exercising any CCPA/CPRA rights
										</li>
									</ul>
									<p>
										To exercise your California privacy rights, contact us at legal@dalbumx.com with 
										the subject line "CCPA/CPRA Request." We will verify your identity and respond within 45 days.
										Residents of other states with applicable comprehensive privacy legislation may contact us at 
										the same address with the subject line "State Privacy Request.
									</p>

									<h2 className="fw-bold mt-4 mb-3 heading-bold">7. CHILDREN'S PRIVACY</h2>

									<p>
										<strong>The DalbumX Service is intended solely for users 18 years of age or older. </strong>
										We do not knowingly collect personal information from any person under 18. 
										If we discover or are notified that a user is under 18, we will immediately 
										terminate their account and permanently delete all associated data. 
										If you believe a minor has created an account, please contact us immediately at legal@dalbumx.com.
									</p>

									<h2 className="fw-bold mt-4 mb-3 heading-bold">8. GEOGRAPHIC SCOPE</h2>

									<p>
										The DalbumX Service is currently available to residents of the United States only.
										All personal data is stored on servers located in the United States.
										Users who access the Service from outside the United States — including 
										through the use of a VPN or while traveling internationally — do so at their 
										own risk and are solely responsible for compliance with their local laws. 
										DalbumX makes no representation that the Service is appropriate or legally 
										available in any jurisdiction outside the United States
									</p>

									<h2 className="fw-bold mt-4 mb-3 heading-bold">9. THIRD-PARTY LINKS AND SERVICES</h2>

									<p>
										The Service may contain links to third-party websites and services. 
										DalbumX is not responsible for the privacy practices of any third party. 
										We encourage you to review the privacy policies of any third-party service 
										you access through or in connection with the DalbumX platform.
									</p>

									<h2 className="fw-bold mt-4 mb-3 heading-bold">10. CHANGES TO THIS PRIVACY POLICY</h2>

									<p>
										We may update this Privacy Policy from time to time. 
										If we make material changes, we will notify you by email at
										least 30 days before the changes take effect and post a 
										prominent notice on the Service. Your continued use of the Service 
										after the effective date of any update constitutes your acceptance 
										of the revised Privacy Policy. The date of the most recent revision 
										appears at the top of this document.
									</p>

									<h2 className="fw-bold mt-4 mb-3 heading-bold">11. CONTACT US</h2>

									<p>
										If you have questions or concerns about this
										Privacy Policy or our privacy practices, please
										contact us:
									</p>

									<ul>
										<li>
											<strong>Privacy and Legal Inquiries:</strong> legal@dalbumx.com
										</li>
										<li>
											<strong>General Support:</strong> support@dalbumx.com
										</li>
										<li>
											<strong>Copyright and DMCA:</strong> copyright@dalbumx.com
										</li>
									</ul>

									<p>
										<strong>Mailing Address:</strong>
										<br />
										DalbumX LLC
										<br />
										534 3rd Ave. #1204
										<br />
										Brooklyn, NY 11215
									</p>

									<p>
										<strong>Registered: </strong> State of Florida, United States of
										America
									</p>

									<p>
										We will respond to all privacy-related
										inquiries within 30 days of receipt.
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>

			<Footer />
		</div>
	);
};

export default PrivacyPolicy;